import React from 'react';

const MagnifyingGlass = ({ color = 'currentColor', size = 40 }: { color?: string, size?: number }) => {
  return <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M17.5 6.25C11.2868 6.25 6.25 11.2868 6.25 17.5C6.25 23.7132 11.2868 28.75 17.5 28.75C20.6069 28.75 23.4177 27.4922 25.455 25.455C27.4922 23.4177 28.75 20.6069 28.75 17.5C28.75 11.2868 23.7132 6.25 17.5 6.25ZM3.75 17.5C3.75 9.90608 9.90608 3.75 17.5 3.75C25.0939 3.75 31.25 9.90608 31.25 17.5C31.25 20.8464 30.0533 23.9151 28.0665 26.2988L35.8839 34.1161C36.372 34.6043 36.372 35.3957 35.8839 35.8839C35.3957 36.372 34.6043 36.372 34.1161 35.8839L26.2988 28.0665C23.9151 30.0533 20.8464 31.25 17.5 31.25C9.90608 31.25 3.75 25.0939 3.75 17.5Z"
          fill={color}/>
  </svg>;
};

export default MagnifyingGlass;
